
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Component, Input, OnInit, forwardRef } from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.css'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatePickerComponent),
        multi: true
    }]
})
export class DatePickerComponent implements OnInit, ControlValueAccessor {
    @Input() nzPlaceHolder: string;
    @Input() nzDisabledDate: (Date) => boolean;
    @Input() nzSize: string;
    @Input() nzDisabled: boolean;
    @Input() nzAllowClear: boolean;

    constructor() { }
    ngOnInit() {
    }

    private _date: Date;
    get date(): Date {
        return this._date;
    }
    set date(v: Date) {
        this._date = v;
        this._value = this.toStr(v);
        this.notifyValueChange();
    }

    private _value = '';
    set value(v: string) {
        this._value = v;
        this._date = this.toDate(v);
    }
    get value() {
        return this._value;
    }

    toDate(v: string) {
        const mom = moment(v, 'YYYY-MM-DD');
        return mom.isValid() ? mom.toDate() : null;
    }

    toStr(v: Date) {
        if (!v) return '';
        const mom = moment(v);
        return mom.isValid() ? mom.format('YYYY-MM-DD') : '';
    }

    //#region ControlValueAccessor
    onChange: (value) => {};
    onTouched: () => {};
    notifyValueChange() {
        if (this.onChange) {
            this.onChange(this.value);
        }
    }
    // write value to element
    writeValue(obj: any): void {
        this.value = obj;
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled: boolean): void {
        this.nzDisabled = isDisabled;
    }
    //#endregion

}




// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/date-picker/date-picker.component.ts